import styled, { css } from "styled-components";
import eyeSolid from "assets/images/icons/eye-solid.png";
import eyeSlash from "assets/images/icons/eye-slash-solid.png";

/* ---------- MAIN PAGE CONTAINER ---------- */

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.gstWhite};
  display: flex;
  flex-direction: column;
`;

/* ---------- SIGNUP SECTION ---------- */

export const SignUpSection = styled.section`
  display: flex;
  align-items: flex-start;
  padding: 0rem;

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 1rem;
  }
`;

/* ---------- RIGHT FORM CONTAINER ---------- */

export const ContainerRight = styled.div`
  width: 37%;
  padding: 40px;
  position: relative;

  @media (max-width: 767px) {
    width: 100%;
    padding: 20% 0rem;
    order: 1;
  }

  @media (min-width: 768px) and (max-width: 1440px) {
    width: 55%;
  }
`;

/* ---------- TITLES ---------- */

export const DiscountTitle = styled.h3`
  font-size: 18px;
  margin-bottom: 22px;
  font-weight: 500;
  line-height: 1.3;
`;

/* ---------- FORM ---------- */

export const SignupForm = styled.form`
  ${({ theme }) => css`
    background-color: ${theme.colors.gstdarkGrey};
    box-shadow: 0 15px 15px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    border-radius: 18px;
    position: relative;

    input {
      margin-bottom: 0.4rem;
      border-radius: 4px;
    }

    @media (max-width: 767px) {
      padding: 1.5rem;
    }
  `}
`;

/* ---------- PASSWORD ---------- */

export const PasswordWrapper = styled.div`
  position: relative;
`;

export const PasswordInfo = styled.div`
  font-size: 0.85rem;
  color: #6c757d;
  margin: 4px 0 10px 2px;
`;

/* ---------- EYE ICON ---------- */

export const EyeContainer = styled.div`
  position: absolute;
  right: 12px;
  top: 24%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;

  &:hover {
    opacity: 0.7;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    /* Medium screens */
    right: 12px;
    top: 20%;
  }

  @media (max-width: 767px) {
    /* Small screens */
    right: 12px;
    top: 20%;
  }
`;

export const Eye = styled.div``;

export const BsEyeFill = styled.div`
  width: 20px;
  height: 20px;
  background-image: url(${eyeSolid});
  background-repeat: no-repeat;
  background-position: center;
`;

export const BsEyeSlashFill = styled.div`
  width: 20px;
  height: 20px;
  background-image: url(${eyeSlash});
  background-repeat: no-repeat;
  background-position: center;
`;

/* ---------- BUTTON SECTION ---------- */

export const ButtonClass = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  p {
    font-size: 0.75rem;
    color: rgb(116, 112, 112);

    a {
      color: #66d7d1;
      margin-left: 4px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

/* ---------- ALREADY REGISTERED ---------- */

export const AlreadyRegistered = styled.div`
  margin-top: 1.5rem;
  font-size: 0.875rem;
  text-align: right;

  a {
    color: #66d7d1;
    text-decoration: none;
  }

  @media (max-width: 767px) {
    text-align: center;
  }
`;

/* ---------- CHECKBOX ---------- */

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;

  input {
    width: 16px;
    height: 16px;
  }

  label {
    font-size: 14px;
    color: #333;
  }

  @media (max-width: 480px) {
    label {
      font-size: 12px;
    }
  }
`;

/* ---------- RESPONSE / ALERT ---------- */

export const Overlay = styled.div`
  width: 100%;
  position: relative;
`;

export const Response = styled.div`
  margin-bottom: 1.5rem;
  padding: 0.5rem 0.5rem;
  border-radius: 8px;
  background: ${({ type }) => (type === "success" ? "#e0ffe0" : "#ffe0e0")};
  color: ${({ type }) => (type === "success" ? "#007500" : "#c01616")};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
`;

export const ResponseContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between; /* Distribute items across the container */

  & > *:nth-child(1) {
    flex-grow: 0; /* Align the first item to the start */
  }

  & > *:nth-child(2) {
    flex-grow: 1;
    margin-left: 0.5rem;
  }

  & > *:nth-child(3) {
    flex-grow: 0; /* Align the third item to the end */
    text-align: right;
  }
`;
export const ResponseMessage = styled.span`
  font-weight: 600;
  font-size: 1rem;
  @media (max-width: 767px) {
    position: relative; /* Reduce width for mobile view */
    font-size: 0.6rem;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    /* Medium screens */
    position: relative; /* Reduce width for mobile view */
    font-size: 0.7rem;
  }
`;

export const AlertIcon = styled.span`
  width: 26px;
  height: 26px;
  background-color: white;
  color: ${({ state }) => (state === "error" ? "#d10000" : "#007500")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  svg {
    width: 22px;
    height: 22px;
  }
  @media only screen and (max-width: 767px) {
  svg {
    width: 12px;
    height: 12px;
  }
  width:16px;
  height:16px;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
  svg {
    width: 17px;
    height: 17px;
  }
  width:21px;
  height:21px;
  }
  }
`;

/* ---------- CLOSE BUTTON ---------- */

export const CloseButton = styled.button`
  background: transparent;
  display: flex;
  color: #d10000;
  font-weight: bold;
  font-size: 1.4rem;
  border: none;
  cursor: pointer;
  position: absolute; /* Position the button absolutely */
  top: 0; /* Align to the top */
  right: 0; /* Align to the right */
  margin: 1rem; /* Add some spacing from the edges */

  svg {
    width: 10%;
    height: 10%;
  }

  @media only screen and (max-width: 767px) {
    font-size: 0.5rem;
    margin: 0.5rem; /* Adjust margin for smaller screens */
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 0.8rem;
    margin: 0.8rem; /* Adjust margin for medium screens */
  }
`;

/* ---------- ERROR ---------- */

export const ErrorMessage = styled.p`
  color: red;
  font-size: 13px;
  margin-top: 4px;
`;
